import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../src/pages/home";
import Privacy from "../src/pages/privacy";
import Error from "../src/pages/error";

function App() {
  return React.createElement(
    Routes,
    null,
    React.createElement(Route, { path: "/", element: React.createElement(Home) }),
    React.createElement(Route, { path: "/privacy", element: React.createElement(Privacy) }),
    React.createElement(Route, { path: "*", element: React.createElement(Error) }),
  );
}

export default App;